export enum BookMeetingStatus {
    MeetingBooked = 'MeetingBooked',
    EmailVerificationRequired = 'EmailVerificationRequired',
    EmailVerificationFailed = 'EmailVerificationFailed',
    AvailabilityNoLongerValid = 'AvailabilityNoLongerValid',
    LeadTimeNotLongerValid = 'LeadTimeNotLongerValid',
    BookingValidationFailed = 'BookingValidationFailed',
    BookingCannotBeUpdated = 'BookingCannotBeUpdated',
    MeetingCancelled = 'MeetingCancelled',
    MeetingCannotBeChanged = 'MeetingCannotBeChanged',
    CancelMeetingFailed = 'CancelMeetingFailed',
    Unknown = 'Unknown',
    NotInitiated = 'NotInitiated',
}
